import React, { useEffect } from 'react';
import { BACKOFFICE_URL} from '../shared/constants';
const BackOffice = () => {
    useEffect(() => window.location.replace(BACKOFFICE_URL), [])
    return <h1>Back office...</h1>;
}

export default BackOffice